import type { ContentPage as Page } from "@neus/shared";
import { usePageTitle } from "../../usePageTitle";
import { Sections } from "./Sections";

/** A page from brands/<id>/pages/*.json. */
export function ContentPage({ page }: { page: Page }) {
  usePageTitle(page.title);
  return <Sections sections={page.sections} />;
}
